/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { access } from 'fs';
import { storeType } from '../store';

export default function Aside() {
  const navigate = useNavigate();
  const { id, role } = useSelector(({ adminReducer }: storeType) => adminReducer);

  if (role === 'reffers') {
    return (
      <div className="aside card-bg">
        <div className="aside-logo-wrapper">
          <svg width="204" height="48" viewBox="0 0 204 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M197.213 34.9746V22.9746C197.213 18.0746 194.213 16.1746 189.413 16.1746C187.213 16.1746 184.813 16.5746 183.613 16.8746C183.213 16.9746 183.013 17.2746 183.013 17.5746V20.2746C183.013 20.6746 183.313 20.8746 183.613 20.8746H183.813C184.813 20.7746 187.213 20.6746 189.413 20.6746C191.013 20.6746 191.913 21.0746 191.913 22.9746V23.5746V24.1746V27.4746V31.1746C191.113 31.5746 190.213 31.8746 189.313 31.8746C187.913 31.8746 187.213 31.5746 187.213 30.1746V29.8746C187.213 28.3746 187.713 27.5746 189.613 27.4746C190.613 27.3746 190.513 27.1746 190.513 26.6746V25.2746C190.513 24.6746 190.613 24.2746 189.513 24.3746C184.213 24.4746 181.913 26.2746 181.913 30.0746V30.3746C181.913 34.7746 184.713 36.1746 187.613 36.1746C189.613 36.1746 191.013 35.5746 192.313 34.6746V35.1746C192.313 35.5746 192.613 35.8746 193.013 35.8746H196.813C196.913 35.6746 197.213 35.3746 197.213 34.9746ZM125.913 30.2746C125.913 28.4746 125.313 26.6746 122.513 25.0746L118.313 22.6746C117.613 22.2746 117.313 21.9746 117.313 21.4746C117.313 20.6746 117.813 20.4746 119.113 20.4746C120.813 20.4746 123.713 20.7746 124.713 20.8746H124.813C125.113 20.8746 125.413 20.6746 125.413 20.2746V17.5746C125.413 17.1746 125.213 16.8746 124.813 16.7746C123.113 16.3746 121.513 15.9746 118.813 15.9746C114.213 15.9746 111.913 17.7746 111.913 21.1746C111.913 23.3746 113.013 25.0746 114.913 26.1746L119.313 28.6746C120.213 29.1746 120.513 29.5746 120.513 30.0746C120.513 30.9746 120.113 31.3746 118.513 31.3746C117.413 31.3746 114.613 31.1746 112.813 30.8746H112.713C112.313 30.8746 112.113 31.1746 112.113 31.4746V34.4746C112.113 34.8746 112.313 35.1746 112.713 35.2746C114.413 35.7746 117.013 35.9746 118.813 35.9746C123.613 35.9746 125.913 33.4746 125.913 30.2746ZM144.113 34.9746V22.9746C144.113 18.0746 141.113 16.1746 136.313 16.1746C134.113 16.1746 131.713 16.5746 130.513 16.8746C130.113 16.9746 129.913 17.2746 129.913 17.5746V20.2746C129.913 20.6746 130.213 20.8746 130.513 20.8746H130.713C131.713 20.7746 134.113 20.6746 136.313 20.6746C137.913 20.6746 138.813 21.0746 138.813 22.9746V23.5746V24.1746V27.4746V31.1746C138.013 31.5746 137.113 31.8746 136.213 31.8746C134.813 31.8746 134.113 31.5746 134.113 30.1746V29.8746C134.113 28.3746 134.613 27.5746 136.513 27.4746C137.513 27.3746 137.413 27.1746 137.413 26.6746V25.2746C137.413 24.6746 137.513 24.2746 136.413 24.3746C131.113 24.4746 128.813 26.2746 128.813 30.0746V30.3746C128.813 34.7746 131.613 36.1746 134.513 36.1746C136.513 36.1746 137.913 35.5746 139.213 34.6746V35.1746C139.213 35.5746 139.513 35.8746 139.913 35.8746H143.713C143.813 35.6746 144.113 35.3746 144.113 34.9746ZM164.713 34.9746V23.7746C164.713 19.5746 163.613 16.1746 158.813 16.1746C156.713 16.1746 155.213 16.5746 153.313 17.8746V17.0746C153.313 16.6746 153.013 16.3746 152.613 16.3746H148.813C148.413 16.3746 148.113 16.6746 148.113 17.0746V34.8746C148.113 35.2746 148.413 35.5746 148.813 35.5746H152.913C153.313 35.5746 153.613 35.2746 153.613 34.8746V21.7746C154.713 21.1746 155.813 20.6746 156.713 20.6746C158.713 20.6746 159.213 21.4746 159.213 23.7746V34.9746C159.213 35.3746 159.513 35.6746 159.913 35.6746H164.013C164.313 35.6746 164.713 35.2746 164.713 34.9746ZM179.313 34.9746V32.3746C179.313 31.9746 179.013 31.7746 178.613 31.7746H177.013C176.013 31.7746 175.913 31.5746 175.913 30.1746V20.4746H178.613C179.013 20.4746 179.313 20.1746 179.313 19.7746V17.0746C179.313 16.6746 179.013 16.3746 178.613 16.3746H175.913V12.8746C175.913 12.5746 175.613 12.2746 175.313 12.2746H175.213L171.113 12.9746C170.713 13.0746 170.413 13.2746 170.413 13.6746V16.4746H167.713C167.313 16.4746 167.013 16.7746 167.013 17.1746V19.3746C167.013 19.7746 167.313 19.9746 167.713 20.0746L170.413 20.4746V30.1746C170.413 34.9746 172.313 35.8746 176.013 35.8746C177.013 35.8746 177.613 35.7746 178.613 35.5746C179.113 35.5746 179.313 35.3746 179.313 34.9746Z" fill="#006CB6" />
            <path fillRule="evenodd" clipRule="evenodd" d="M55.8126 18.9746V17.5746C55.8126 17.1746 55.6126 16.9746 55.1126 16.9746C53.6126 16.9746 52.1126 17.3746 50.4126 18.5746V17.8746C50.4126 17.4746 50.1126 17.1746 49.8126 17.1746H48.2126C47.8126 17.1746 47.6126 17.4746 47.6126 17.8746V34.9746C47.6126 35.3746 47.9126 35.6746 48.2126 35.6746H49.8126C50.2126 35.6746 50.5126 35.3746 50.5126 34.9746V20.9746C52.2126 19.9746 53.6126 19.5746 55.1126 19.5746C55.6126 19.5746 55.8126 19.3746 55.8126 18.9746ZM72.4126 26.6746V24.8746C72.4126 20.0746 69.9126 17.0746 65.0126 17.0746C60.2126 17.0746 57.6126 20.0746 57.6126 24.8746V27.8746C57.6126 34.0746 61.4126 35.8746 65.2126 35.8746C67.4126 35.8746 69.3126 35.6746 71.2126 35.2746C71.7126 35.1746 71.9126 34.9746 71.9126 34.4746V33.3746C71.9126 33.0746 71.6126 32.8746 71.4126 32.8746C71.3126 32.8746 71.3126 32.8746 71.2126 32.8746C69.7126 33.0746 67.2126 33.2746 65.2126 33.2746C62.1126 33.2746 60.5126 31.7746 60.5126 27.7746V27.2746H71.7126C72.1126 27.3746 72.4126 27.0746 72.4126 26.6746ZM69.4126 25.1746H60.5126V24.8746C60.5126 21.2746 62.1126 19.5746 65.0126 19.5746C67.9126 19.5746 69.4126 21.0746 69.4126 24.8746V25.1746ZM90.0126 34.5746V11.0746C90.0126 10.6746 89.7126 10.4746 89.4126 10.4746H87.7126C87.3126 10.4746 87.1126 10.7746 87.1126 11.0746V16.4746V17.3746V19.8746V20.9746V33.1746C86.0126 33.2746 84.3126 33.3746 83.2126 33.3746C79.9126 33.3746 78.8126 31.3746 78.8126 27.6746V25.2746C78.8126 21.6746 79.9126 19.6746 83.2126 19.6746C84.2126 19.6746 84.2126 19.5746 84.2126 19.0746V17.9746C84.2126 17.4746 84.3126 17.1746 83.2126 17.1746C78.3126 17.1746 75.9126 20.0746 75.9126 25.3746V27.7746C75.9126 32.7746 78.2126 36.0746 83.2126 36.0746C85.2126 36.0746 87.3126 35.8746 89.4126 35.4746C89.9126 35.1746 90.0126 34.9746 90.0126 34.5746ZM108.713 26.6746V24.8746C108.713 20.0746 106.213 17.0746 101.313 17.0746C96.5126 17.0746 93.9126 20.0746 93.9126 24.8746V27.8746C93.9126 34.0746 97.7126 35.8746 101.513 35.8746C103.713 35.8746 105.613 35.6746 107.513 35.2746C108.013 35.1746 108.213 34.9746 108.213 34.4746V33.3746C108.213 33.0746 107.913 32.8746 107.713 32.8746C107.613 32.8746 107.613 32.8746 107.513 32.8746C106.013 33.0746 103.513 33.2746 101.513 33.2746C98.4126 33.2746 96.8126 31.7746 96.8126 27.7746V27.2746H108.013C108.513 27.3746 108.713 27.0746 108.713 26.6746ZM105.713 25.1746H96.8126V24.8746C96.8126 21.2746 98.4126 19.5746 101.313 19.5746C104.213 19.5746 105.713 21.0746 105.713 24.8746V25.1746Z" fill="#1EBCBE" />
            <path fillRule="evenodd" clipRule="evenodd" d="M201.313 16.9746C202.513 16.9746 203.413 17.8746 203.413 19.0746C203.413 20.2746 202.513 21.1746 201.313 21.1746C200.113 21.1746 199.213 20.2746 199.213 19.0746C199.213 17.9746 200.113 16.9746 201.313 16.9746ZM200.813 18.3746V18.9746H201.313C201.413 18.9746 201.513 18.9746 201.513 18.9746C201.613 18.9746 201.613 18.8746 201.613 18.6746C201.613 18.5746 201.613 18.4746 201.513 18.3746C201.413 18.3746 201.413 18.3746 201.313 18.3746H200.813ZM201.513 17.9746H200.413V20.1746H200.913V19.2746H201.413C201.513 19.2746 201.613 19.2746 201.713 19.3746C201.813 19.3746 201.813 19.4746 201.813 19.6746V19.8746C201.813 19.9746 201.813 19.9746 201.813 20.0746V20.1746H202.313V20.0746L202.213 19.9746C202.213 19.9746 202.213 19.8746 202.213 19.7746V19.5746C202.213 19.3746 202.213 19.2746 202.113 19.1746C202.113 19.0746 202.013 19.0746 201.913 18.9746C202.013 18.9746 202.113 18.8746 202.213 18.7746C202.313 18.6746 202.313 18.5746 202.313 18.4746C202.313 18.3746 202.313 18.2746 202.313 18.2746C202.313 18.1746 202.213 18.1746 202.213 18.0746C202.113 17.9746 202.113 17.9746 202.013 17.8746C201.713 18.0746 201.613 17.9746 201.513 17.9746ZM201.313 17.3746C200.313 17.3746 199.513 18.1746 199.513 19.1746C199.513 20.1746 200.313 20.9746 201.313 20.9746C202.313 20.9746 203.113 20.1746 203.113 19.1746C203.113 18.1746 202.313 17.3746 201.313 17.3746Z" fill="#006CB6" />
            <path d="M32.9173 38.7794C41.1356 33.7986 43.7601 23.0987 38.7794 14.8805C33.7986 6.66221 23.0987 4.03768 14.8805 9.01841C6.66222 13.9992 4.03768 24.6991 9.01842 32.9173C13.9992 41.1356 24.6991 43.7601 32.9173 38.7794Z" fill="#006CB6" />
            <path d="M23.9126 40.4746C33.0805 40.4746 40.5126 33.0426 40.5126 23.8746C40.5126 14.7067 33.0805 7.27464 23.9126 7.27464C14.7447 7.27464 7.31262 14.7067 7.31262 23.8746C7.31262 33.0426 14.7447 40.4746 23.9126 40.4746Z" fill="url(#paint0_linear_336_4)" />
            <path d="M34.9986 35.0129C41.1297 28.8817 41.1297 18.9411 34.9986 12.81C28.8674 6.6788 18.9268 6.6788 12.7956 12.81C6.66445 18.9411 6.66445 28.8817 12.7956 35.0129C18.9268 41.1441 28.8674 41.1441 34.9986 35.0129Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M18.9126 13.4746C19.7126 13.5746 20.2126 14.3746 20.0126 15.0746C19.9126 15.8746 19.1126 16.3746 18.4126 16.1746C17.6126 16.0746 17.1126 15.2746 17.3126 14.5746C17.4126 13.8746 18.1126 13.2746 18.9126 13.4746Z" fill="#1EBCBE" />
            <path fillRule="evenodd" clipRule="evenodd" d="M18.7126 22.1746C19.1126 21.8746 19.6126 21.5746 20.1126 21.4746C20.9126 21.1746 21.8126 21.0746 22.7126 21.2746C22.9126 21.2746 23.0126 21.4746 23.0126 21.6746C23.0126 22.0746 23.0126 22.3746 22.9126 22.7746C22.9126 22.9746 22.7126 23.0746 22.4126 23.0746C21.8126 22.9746 21.2126 22.9746 20.6126 23.1746C19.8126 23.4746 19.2126 23.9746 18.8126 24.6746C18.8126 24.7746 18.7126 24.8746 18.6126 24.8746C18.6126 24.8746 18.6126 24.8746 18.5126 24.8746C18.4126 24.8746 18.3126 24.8746 18.2126 24.8746C17.9126 24.5746 17.6126 24.1746 17.4126 23.7746C17.3126 23.5746 17.2126 23.3746 17.1126 23.1746C16.1126 20.4746 17.5126 17.5746 20.2126 16.5746C22.9126 15.5746 25.8126 16.9746 26.8126 19.6746C26.9126 20.0746 27.0126 20.3746 27.1126 20.7746C27.1126 20.8746 27.1126 21.0746 26.9126 21.1746C26.8126 21.2746 26.6126 21.2746 26.5126 21.1746C26.2126 20.9746 25.9126 20.8746 25.5126 20.7746C25.4126 20.7746 25.3126 20.6746 25.2126 20.4746C25.2126 20.3746 25.1126 20.2746 25.1126 20.1746C24.5126 18.3746 22.5126 17.4746 20.7126 18.0746C19.1126 18.5746 18.1126 20.4746 18.7126 22.1746Z" fill="#1EBCBE" />
            <path fillRule="evenodd" clipRule="evenodd" d="M25.0126 22.8746C25.0126 22.7746 25.1126 22.6746 25.2126 22.6746C25.2126 22.6746 25.2126 22.6746 25.3126 22.6746C25.4126 22.6746 25.5126 22.6746 25.6126 22.6746C25.9126 22.9746 26.2126 23.3746 26.4126 23.7746C26.5126 23.9746 26.6126 24.1746 26.7126 24.3746C27.7126 27.0746 26.3126 29.9746 23.6126 30.9746C20.9126 31.9746 18.0126 30.5746 17.0126 27.8746C16.9126 27.4746 16.8126 27.1746 16.7126 26.7746C16.7126 26.6746 16.7126 26.4746 16.9126 26.3746C17.0126 26.2746 17.2126 26.2746 17.3126 26.3746C17.6126 26.5746 17.9126 26.6746 18.3126 26.7746C18.4126 26.7746 18.5126 26.8746 18.6126 27.0746C18.6126 27.1746 18.7126 27.2746 18.7126 27.3746C19.3126 29.1746 21.3126 30.0746 23.1126 29.4746C24.8126 28.8746 25.8126 26.9746 25.2126 25.2746C24.8126 25.5746 24.3126 25.8746 23.8126 25.9746C23.0126 26.2746 22.1126 26.3746 21.2126 26.1746C21.0126 26.1746 20.9126 25.9746 20.9126 25.7746C20.9126 25.3746 20.9126 25.0746 21.0126 24.6746C21.1126 24.4746 21.2126 24.3746 21.5126 24.3746C22.1126 24.4746 22.7126 24.4746 23.3126 24.2746C23.9126 24.1746 24.6126 23.5746 25.0126 22.8746Z" fill="#006CB6" />
            <path fillRule="evenodd" clipRule="evenodd" d="M27.4126 27.8746C28.8126 27.6746 30.0126 26.5746 30.3126 25.0746C30.6126 23.2746 29.4126 21.4746 27.6126 21.0746C27.7126 20.8746 27.8126 20.6746 27.7126 20.3746C27.7126 19.9746 27.6126 19.6746 27.5126 19.2746C27.6126 19.2746 27.7126 19.2746 27.8126 19.2746C30.6126 19.7746 32.5126 22.4746 32.0126 25.2746C31.8126 26.5746 31.0126 27.7746 29.9126 28.5746C28.9126 29.2746 27.8126 29.5746 26.6126 29.5746C27.0126 29.0746 27.3126 28.4746 27.4126 27.8746Z" fill="#006CB6" />
            <path fillRule="evenodd" clipRule="evenodd" d="M28.7126 23.1746C29.3126 23.2746 29.8126 23.8746 29.6126 24.4746C29.5126 25.0746 28.9126 25.5746 28.3126 25.3746C27.7126 25.2746 27.2126 24.6746 27.4126 24.0746C27.5126 23.5746 28.1126 23.0746 28.7126 23.1746Z" fill="#006CB6" />
            <path fillRule="evenodd" clipRule="evenodd" d="M24.4126 31.5746C25.2126 31.6746 25.7126 32.4746 25.5126 33.1746C25.4126 33.9746 24.6126 34.4746 23.9126 34.2746C23.1126 34.1746 22.6126 33.3746 22.8126 32.6746C22.9126 31.9746 23.7126 31.4746 24.4126 31.5746Z" fill="#006CB6" />
            <defs>
              <linearGradient id="paint0_linear_336_4" x1="15.2815" y1="15.1658" x2="33.6894" y2="33.7387" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F27172" />
                <stop offset="1" stopColor="#1EBCBE" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="menu-section">
          <button type="button" onClick={() => navigate('/')}>
            <span className="material-icons-round">
              cottage
            </span>
            <p>Dashboard</p>
          </button>
          <div className="sub-menu-invisible">
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/dashboard/consulta-por-cpf')}>
                <span className="material-icons-round">
                  category
                </span>
                Consulta por CPF
              </button>
            </div>
            {/* <div className="invisible-item">
              <button type="button" onClick={() => navigate('/dashboard/consulta-por-nome')}>
                <span className="material-icons-round">
                  category
                </span>
                Busca por Nome
              </button>
            </div>
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/dashboard/vidas')}>
                <span className="material-icons-round">
                  category
                </span>
                Status associados
              </button>
            </div> */}
          </div>
        </div>
        {/* <div className="menu-section">
          <button type="button" className="menu-btn-main">
            <span className="material-icons-round">
              track_changes
            </span>
            <p>Clientes</p>
          </button>
          <div className="sub-menu-invisible">
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/cliente/pessoa-fisica')}>
                <span className="material-icons-round">
                  category
                </span>
                Pessoa Física
              </button>
            </div>
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/cliente/empresa')}>
                <span className="material-icons-round">
                  category
                </span>
                Pessoa Jurídica
              </button>
            </div>
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/cliente/pf/bloqueados-permanentemente')}>
                <span className="material-icons-round">
                  category
                </span>
                Associados cancelados
              </button>
            </div>
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/cliente/pf/lead')}>
                <span className="material-icons-round">
                  category
                </span>
                Termo de Adesão PF
              </button>
            </div>
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/cliente/pj/lead')}>
                <span className="material-icons-round">
                  category
                </span>
                Termo de Adesão PJ
              </button>
            </div>
          </div>
        </div>

        <div className="menu-section">
          <button type="button" className="menu-btn-main">
            <span className="material-icons-round">
              gavel
            </span>
            <p>Contratos</p>
          </button>

          <div className="sub-menu-invisible">
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/contratos/pj')}>
                <span className="material-icons-round">
                  category
                </span>
                Pessoa Jurídica
              </button>
            </div>
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/contratos/pf')}>
                <span className="material-icons-round">
                  category
                </span>
                Pessoa Física
              </button>
            </div>
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/contratos/expiracao')}>
                <span className="material-icons-round">
                  category
                </span>
                Contratos a Expirar
              </button>
            </div>
          </div>
        </div> */}
      </div>
    );
  }
  return (
    <div className="aside card-bg">
      <div className="aside-logo-wrapper">
        <svg width="204" height="48" viewBox="0 0 204 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M197.213 34.9746V22.9746C197.213 18.0746 194.213 16.1746 189.413 16.1746C187.213 16.1746 184.813 16.5746 183.613 16.8746C183.213 16.9746 183.013 17.2746 183.013 17.5746V20.2746C183.013 20.6746 183.313 20.8746 183.613 20.8746H183.813C184.813 20.7746 187.213 20.6746 189.413 20.6746C191.013 20.6746 191.913 21.0746 191.913 22.9746V23.5746V24.1746V27.4746V31.1746C191.113 31.5746 190.213 31.8746 189.313 31.8746C187.913 31.8746 187.213 31.5746 187.213 30.1746V29.8746C187.213 28.3746 187.713 27.5746 189.613 27.4746C190.613 27.3746 190.513 27.1746 190.513 26.6746V25.2746C190.513 24.6746 190.613 24.2746 189.513 24.3746C184.213 24.4746 181.913 26.2746 181.913 30.0746V30.3746C181.913 34.7746 184.713 36.1746 187.613 36.1746C189.613 36.1746 191.013 35.5746 192.313 34.6746V35.1746C192.313 35.5746 192.613 35.8746 193.013 35.8746H196.813C196.913 35.6746 197.213 35.3746 197.213 34.9746ZM125.913 30.2746C125.913 28.4746 125.313 26.6746 122.513 25.0746L118.313 22.6746C117.613 22.2746 117.313 21.9746 117.313 21.4746C117.313 20.6746 117.813 20.4746 119.113 20.4746C120.813 20.4746 123.713 20.7746 124.713 20.8746H124.813C125.113 20.8746 125.413 20.6746 125.413 20.2746V17.5746C125.413 17.1746 125.213 16.8746 124.813 16.7746C123.113 16.3746 121.513 15.9746 118.813 15.9746C114.213 15.9746 111.913 17.7746 111.913 21.1746C111.913 23.3746 113.013 25.0746 114.913 26.1746L119.313 28.6746C120.213 29.1746 120.513 29.5746 120.513 30.0746C120.513 30.9746 120.113 31.3746 118.513 31.3746C117.413 31.3746 114.613 31.1746 112.813 30.8746H112.713C112.313 30.8746 112.113 31.1746 112.113 31.4746V34.4746C112.113 34.8746 112.313 35.1746 112.713 35.2746C114.413 35.7746 117.013 35.9746 118.813 35.9746C123.613 35.9746 125.913 33.4746 125.913 30.2746ZM144.113 34.9746V22.9746C144.113 18.0746 141.113 16.1746 136.313 16.1746C134.113 16.1746 131.713 16.5746 130.513 16.8746C130.113 16.9746 129.913 17.2746 129.913 17.5746V20.2746C129.913 20.6746 130.213 20.8746 130.513 20.8746H130.713C131.713 20.7746 134.113 20.6746 136.313 20.6746C137.913 20.6746 138.813 21.0746 138.813 22.9746V23.5746V24.1746V27.4746V31.1746C138.013 31.5746 137.113 31.8746 136.213 31.8746C134.813 31.8746 134.113 31.5746 134.113 30.1746V29.8746C134.113 28.3746 134.613 27.5746 136.513 27.4746C137.513 27.3746 137.413 27.1746 137.413 26.6746V25.2746C137.413 24.6746 137.513 24.2746 136.413 24.3746C131.113 24.4746 128.813 26.2746 128.813 30.0746V30.3746C128.813 34.7746 131.613 36.1746 134.513 36.1746C136.513 36.1746 137.913 35.5746 139.213 34.6746V35.1746C139.213 35.5746 139.513 35.8746 139.913 35.8746H143.713C143.813 35.6746 144.113 35.3746 144.113 34.9746ZM164.713 34.9746V23.7746C164.713 19.5746 163.613 16.1746 158.813 16.1746C156.713 16.1746 155.213 16.5746 153.313 17.8746V17.0746C153.313 16.6746 153.013 16.3746 152.613 16.3746H148.813C148.413 16.3746 148.113 16.6746 148.113 17.0746V34.8746C148.113 35.2746 148.413 35.5746 148.813 35.5746H152.913C153.313 35.5746 153.613 35.2746 153.613 34.8746V21.7746C154.713 21.1746 155.813 20.6746 156.713 20.6746C158.713 20.6746 159.213 21.4746 159.213 23.7746V34.9746C159.213 35.3746 159.513 35.6746 159.913 35.6746H164.013C164.313 35.6746 164.713 35.2746 164.713 34.9746ZM179.313 34.9746V32.3746C179.313 31.9746 179.013 31.7746 178.613 31.7746H177.013C176.013 31.7746 175.913 31.5746 175.913 30.1746V20.4746H178.613C179.013 20.4746 179.313 20.1746 179.313 19.7746V17.0746C179.313 16.6746 179.013 16.3746 178.613 16.3746H175.913V12.8746C175.913 12.5746 175.613 12.2746 175.313 12.2746H175.213L171.113 12.9746C170.713 13.0746 170.413 13.2746 170.413 13.6746V16.4746H167.713C167.313 16.4746 167.013 16.7746 167.013 17.1746V19.3746C167.013 19.7746 167.313 19.9746 167.713 20.0746L170.413 20.4746V30.1746C170.413 34.9746 172.313 35.8746 176.013 35.8746C177.013 35.8746 177.613 35.7746 178.613 35.5746C179.113 35.5746 179.313 35.3746 179.313 34.9746Z" fill="#006CB6" />
          <path fillRule="evenodd" clipRule="evenodd" d="M55.8126 18.9746V17.5746C55.8126 17.1746 55.6126 16.9746 55.1126 16.9746C53.6126 16.9746 52.1126 17.3746 50.4126 18.5746V17.8746C50.4126 17.4746 50.1126 17.1746 49.8126 17.1746H48.2126C47.8126 17.1746 47.6126 17.4746 47.6126 17.8746V34.9746C47.6126 35.3746 47.9126 35.6746 48.2126 35.6746H49.8126C50.2126 35.6746 50.5126 35.3746 50.5126 34.9746V20.9746C52.2126 19.9746 53.6126 19.5746 55.1126 19.5746C55.6126 19.5746 55.8126 19.3746 55.8126 18.9746ZM72.4126 26.6746V24.8746C72.4126 20.0746 69.9126 17.0746 65.0126 17.0746C60.2126 17.0746 57.6126 20.0746 57.6126 24.8746V27.8746C57.6126 34.0746 61.4126 35.8746 65.2126 35.8746C67.4126 35.8746 69.3126 35.6746 71.2126 35.2746C71.7126 35.1746 71.9126 34.9746 71.9126 34.4746V33.3746C71.9126 33.0746 71.6126 32.8746 71.4126 32.8746C71.3126 32.8746 71.3126 32.8746 71.2126 32.8746C69.7126 33.0746 67.2126 33.2746 65.2126 33.2746C62.1126 33.2746 60.5126 31.7746 60.5126 27.7746V27.2746H71.7126C72.1126 27.3746 72.4126 27.0746 72.4126 26.6746ZM69.4126 25.1746H60.5126V24.8746C60.5126 21.2746 62.1126 19.5746 65.0126 19.5746C67.9126 19.5746 69.4126 21.0746 69.4126 24.8746V25.1746ZM90.0126 34.5746V11.0746C90.0126 10.6746 89.7126 10.4746 89.4126 10.4746H87.7126C87.3126 10.4746 87.1126 10.7746 87.1126 11.0746V16.4746V17.3746V19.8746V20.9746V33.1746C86.0126 33.2746 84.3126 33.3746 83.2126 33.3746C79.9126 33.3746 78.8126 31.3746 78.8126 27.6746V25.2746C78.8126 21.6746 79.9126 19.6746 83.2126 19.6746C84.2126 19.6746 84.2126 19.5746 84.2126 19.0746V17.9746C84.2126 17.4746 84.3126 17.1746 83.2126 17.1746C78.3126 17.1746 75.9126 20.0746 75.9126 25.3746V27.7746C75.9126 32.7746 78.2126 36.0746 83.2126 36.0746C85.2126 36.0746 87.3126 35.8746 89.4126 35.4746C89.9126 35.1746 90.0126 34.9746 90.0126 34.5746ZM108.713 26.6746V24.8746C108.713 20.0746 106.213 17.0746 101.313 17.0746C96.5126 17.0746 93.9126 20.0746 93.9126 24.8746V27.8746C93.9126 34.0746 97.7126 35.8746 101.513 35.8746C103.713 35.8746 105.613 35.6746 107.513 35.2746C108.013 35.1746 108.213 34.9746 108.213 34.4746V33.3746C108.213 33.0746 107.913 32.8746 107.713 32.8746C107.613 32.8746 107.613 32.8746 107.513 32.8746C106.013 33.0746 103.513 33.2746 101.513 33.2746C98.4126 33.2746 96.8126 31.7746 96.8126 27.7746V27.2746H108.013C108.513 27.3746 108.713 27.0746 108.713 26.6746ZM105.713 25.1746H96.8126V24.8746C96.8126 21.2746 98.4126 19.5746 101.313 19.5746C104.213 19.5746 105.713 21.0746 105.713 24.8746V25.1746Z" fill="#1EBCBE" />
          <path fillRule="evenodd" clipRule="evenodd" d="M201.313 16.9746C202.513 16.9746 203.413 17.8746 203.413 19.0746C203.413 20.2746 202.513 21.1746 201.313 21.1746C200.113 21.1746 199.213 20.2746 199.213 19.0746C199.213 17.9746 200.113 16.9746 201.313 16.9746ZM200.813 18.3746V18.9746H201.313C201.413 18.9746 201.513 18.9746 201.513 18.9746C201.613 18.9746 201.613 18.8746 201.613 18.6746C201.613 18.5746 201.613 18.4746 201.513 18.3746C201.413 18.3746 201.413 18.3746 201.313 18.3746H200.813ZM201.513 17.9746H200.413V20.1746H200.913V19.2746H201.413C201.513 19.2746 201.613 19.2746 201.713 19.3746C201.813 19.3746 201.813 19.4746 201.813 19.6746V19.8746C201.813 19.9746 201.813 19.9746 201.813 20.0746V20.1746H202.313V20.0746L202.213 19.9746C202.213 19.9746 202.213 19.8746 202.213 19.7746V19.5746C202.213 19.3746 202.213 19.2746 202.113 19.1746C202.113 19.0746 202.013 19.0746 201.913 18.9746C202.013 18.9746 202.113 18.8746 202.213 18.7746C202.313 18.6746 202.313 18.5746 202.313 18.4746C202.313 18.3746 202.313 18.2746 202.313 18.2746C202.313 18.1746 202.213 18.1746 202.213 18.0746C202.113 17.9746 202.113 17.9746 202.013 17.8746C201.713 18.0746 201.613 17.9746 201.513 17.9746ZM201.313 17.3746C200.313 17.3746 199.513 18.1746 199.513 19.1746C199.513 20.1746 200.313 20.9746 201.313 20.9746C202.313 20.9746 203.113 20.1746 203.113 19.1746C203.113 18.1746 202.313 17.3746 201.313 17.3746Z" fill="#006CB6" />
          <path d="M32.9173 38.7794C41.1356 33.7986 43.7601 23.0987 38.7794 14.8805C33.7986 6.66221 23.0987 4.03768 14.8805 9.01841C6.66222 13.9992 4.03768 24.6991 9.01842 32.9173C13.9992 41.1356 24.6991 43.7601 32.9173 38.7794Z" fill="#006CB6" />
          <path d="M23.9126 40.4746C33.0805 40.4746 40.5126 33.0426 40.5126 23.8746C40.5126 14.7067 33.0805 7.27464 23.9126 7.27464C14.7447 7.27464 7.31262 14.7067 7.31262 23.8746C7.31262 33.0426 14.7447 40.4746 23.9126 40.4746Z" fill="url(#paint0_linear_336_4)" />
          <path d="M34.9986 35.0129C41.1297 28.8817 41.1297 18.9411 34.9986 12.81C28.8674 6.6788 18.9268 6.6788 12.7956 12.81C6.66445 18.9411 6.66445 28.8817 12.7956 35.0129C18.9268 41.1441 28.8674 41.1441 34.9986 35.0129Z" fill="white" />
          <path fillRule="evenodd" clipRule="evenodd" d="M18.9126 13.4746C19.7126 13.5746 20.2126 14.3746 20.0126 15.0746C19.9126 15.8746 19.1126 16.3746 18.4126 16.1746C17.6126 16.0746 17.1126 15.2746 17.3126 14.5746C17.4126 13.8746 18.1126 13.2746 18.9126 13.4746Z" fill="#1EBCBE" />
          <path fillRule="evenodd" clipRule="evenodd" d="M18.7126 22.1746C19.1126 21.8746 19.6126 21.5746 20.1126 21.4746C20.9126 21.1746 21.8126 21.0746 22.7126 21.2746C22.9126 21.2746 23.0126 21.4746 23.0126 21.6746C23.0126 22.0746 23.0126 22.3746 22.9126 22.7746C22.9126 22.9746 22.7126 23.0746 22.4126 23.0746C21.8126 22.9746 21.2126 22.9746 20.6126 23.1746C19.8126 23.4746 19.2126 23.9746 18.8126 24.6746C18.8126 24.7746 18.7126 24.8746 18.6126 24.8746C18.6126 24.8746 18.6126 24.8746 18.5126 24.8746C18.4126 24.8746 18.3126 24.8746 18.2126 24.8746C17.9126 24.5746 17.6126 24.1746 17.4126 23.7746C17.3126 23.5746 17.2126 23.3746 17.1126 23.1746C16.1126 20.4746 17.5126 17.5746 20.2126 16.5746C22.9126 15.5746 25.8126 16.9746 26.8126 19.6746C26.9126 20.0746 27.0126 20.3746 27.1126 20.7746C27.1126 20.8746 27.1126 21.0746 26.9126 21.1746C26.8126 21.2746 26.6126 21.2746 26.5126 21.1746C26.2126 20.9746 25.9126 20.8746 25.5126 20.7746C25.4126 20.7746 25.3126 20.6746 25.2126 20.4746C25.2126 20.3746 25.1126 20.2746 25.1126 20.1746C24.5126 18.3746 22.5126 17.4746 20.7126 18.0746C19.1126 18.5746 18.1126 20.4746 18.7126 22.1746Z" fill="#1EBCBE" />
          <path fillRule="evenodd" clipRule="evenodd" d="M25.0126 22.8746C25.0126 22.7746 25.1126 22.6746 25.2126 22.6746C25.2126 22.6746 25.2126 22.6746 25.3126 22.6746C25.4126 22.6746 25.5126 22.6746 25.6126 22.6746C25.9126 22.9746 26.2126 23.3746 26.4126 23.7746C26.5126 23.9746 26.6126 24.1746 26.7126 24.3746C27.7126 27.0746 26.3126 29.9746 23.6126 30.9746C20.9126 31.9746 18.0126 30.5746 17.0126 27.8746C16.9126 27.4746 16.8126 27.1746 16.7126 26.7746C16.7126 26.6746 16.7126 26.4746 16.9126 26.3746C17.0126 26.2746 17.2126 26.2746 17.3126 26.3746C17.6126 26.5746 17.9126 26.6746 18.3126 26.7746C18.4126 26.7746 18.5126 26.8746 18.6126 27.0746C18.6126 27.1746 18.7126 27.2746 18.7126 27.3746C19.3126 29.1746 21.3126 30.0746 23.1126 29.4746C24.8126 28.8746 25.8126 26.9746 25.2126 25.2746C24.8126 25.5746 24.3126 25.8746 23.8126 25.9746C23.0126 26.2746 22.1126 26.3746 21.2126 26.1746C21.0126 26.1746 20.9126 25.9746 20.9126 25.7746C20.9126 25.3746 20.9126 25.0746 21.0126 24.6746C21.1126 24.4746 21.2126 24.3746 21.5126 24.3746C22.1126 24.4746 22.7126 24.4746 23.3126 24.2746C23.9126 24.1746 24.6126 23.5746 25.0126 22.8746Z" fill="#006CB6" />
          <path fillRule="evenodd" clipRule="evenodd" d="M27.4126 27.8746C28.8126 27.6746 30.0126 26.5746 30.3126 25.0746C30.6126 23.2746 29.4126 21.4746 27.6126 21.0746C27.7126 20.8746 27.8126 20.6746 27.7126 20.3746C27.7126 19.9746 27.6126 19.6746 27.5126 19.2746C27.6126 19.2746 27.7126 19.2746 27.8126 19.2746C30.6126 19.7746 32.5126 22.4746 32.0126 25.2746C31.8126 26.5746 31.0126 27.7746 29.9126 28.5746C28.9126 29.2746 27.8126 29.5746 26.6126 29.5746C27.0126 29.0746 27.3126 28.4746 27.4126 27.8746Z" fill="#006CB6" />
          <path fillRule="evenodd" clipRule="evenodd" d="M28.7126 23.1746C29.3126 23.2746 29.8126 23.8746 29.6126 24.4746C29.5126 25.0746 28.9126 25.5746 28.3126 25.3746C27.7126 25.2746 27.2126 24.6746 27.4126 24.0746C27.5126 23.5746 28.1126 23.0746 28.7126 23.1746Z" fill="#006CB6" />
          <path fillRule="evenodd" clipRule="evenodd" d="M24.4126 31.5746C25.2126 31.6746 25.7126 32.4746 25.5126 33.1746C25.4126 33.9746 24.6126 34.4746 23.9126 34.2746C23.1126 34.1746 22.6126 33.3746 22.8126 32.6746C22.9126 31.9746 23.7126 31.4746 24.4126 31.5746Z" fill="#006CB6" />
          <defs>
            <linearGradient id="paint0_linear_336_4" x1="15.2815" y1="15.1658" x2="33.6894" y2="33.7387" gradientUnits="userSpaceOnUse">
              <stop stopColor="#F27172" />
              <stop offset="1" stopColor="#1EBCBE" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <div className="menu-section">
        <button type="button" onClick={() => navigate('/')}>
          <span className="material-icons-round">
            cottage
          </span>
          <p>Dashboard</p>
        </button>
        <div className="sub-menu-invisible">
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/dashboard/consulta-por-cpf')}>
              <span className="material-icons-round">
                category
              </span>
              Consulta por CPF
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/dashboard/consulta-por-nome')}>
              <span className="material-icons-round">
                category
              </span>
              Busca por Nome
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/dashboard/vidas')}>
              <span className="material-icons-round">
                category
              </span>
              Status associados
            </button>
          </div>
        </div>
      </div>

      <div className="menu-section">
        <button type="button" onClick={() => navigate('/produtos')}>
          <span className="material-icons-round">
            sell
          </span>
          <p>Produtos</p>
        </button>
      </div>

      <div className="menu-section">
        <button type="button" className="menu-btn-main">
          <span className="material-icons-round">
            storefront
          </span>
          <p>Vendedor</p>
        </button>

        <div className="sub-menu-invisible">
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/vendedores')}>
              <span className="material-icons-round">
                category
              </span>
              Vendedores
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/representantes')}>
              <span className="material-icons-round">
                category
              </span>
              Representantes
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/embaixador-master')}>
              <span className="material-icons-round">
                category
              </span>
              Embaixadores Master
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/embaixador')}>
              <span className="material-icons-round">
                category
              </span>
              Embaixadores
            </button>
          </div>
        </div>
      </div>

      <div className="menu-section">
        <button type="button" className="menu-btn-main">
          <span className="material-icons-round">
            track_changes
          </span>
          <p>Clientes</p>
        </button>

        <div className="sub-menu-invisible">
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/cliente/motivos-cancelamento')}>
              <span className="material-icons-round">
                category
              </span>
              Motivos de Cancelamento
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/cliente/pessoa-fisica')}>
              <span className="material-icons-round">
                category
              </span>
              Pessoa Física
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/cliente/empresa')}>
              <span className="material-icons-round">
                category
              </span>
              Pessoa Jurídica
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/cliente/pf/bloqueados-permanentemente')}>
              <span className="material-icons-round">
                category
              </span>
              Associados cancelados
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/cliente/pf/lead')}>
              <span className="material-icons-round">
                category
              </span>
              Termo de Adesão PF
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/cliente/pj/lead')}>
              <span className="material-icons-round">
                category
              </span>
              Termo de Adesão PJ
            </button>
          </div>

        </div>
      </div>

      <div className="menu-section">
        <button type="button" className="menu-btn-main">
          <span className="material-icons-round">
            gavel
          </span>
          <p>Contratos</p>
        </button>

        <div className="sub-menu-invisible">
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/contratos/motivos-cancelamento')}>
              <span className="material-icons-round">
                category
              </span>
              Motivos de Cancelamento
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/contratos/pj')}>
              <span className="material-icons-round">
                category
              </span>
              Pessoa Jurídica
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/contratos/pf')}>
              <span className="material-icons-round">
                category
              </span>
              Pessoa Física
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/contratos/expiracao')}>
              <span className="material-icons-round">
                category
              </span>
              Contratos a Expirar
            </button>
          </div>
        </div>
      </div>

      <div className="menu-section">
        <button type="button" className="menu-btn-main">
          <span className="material-icons-round">
            flag
          </span>
          <p>Relatórios</p>
        </button>
        <div className="sub-menu-invisible">
          {/* /dashboard/relatorios/demografico */}
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/dashboard/relatorios/demografico')}>
              <span className="material-icons-round">
                category
              </span>
              Relatório demográfico
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/relatorios-por-data')}>
              <span className="material-icons-round">
                category
              </span>
              Relatórios por data
            </button>
          </div>
          {/* <div className="invisible-item">
            <button type="button" onClick={() => navigate('/relatorio-estratificado')}>
              <span className="material-icons-round">
                category
              </span>
              Relatório Estratificado
            </button>
          </div> */}
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/inconsistencias')}>
              <span className="material-icons-round">
                category
              </span>
              Possíveis inconsistências
            </button>
          </div>
        </div>
      </div>

      <div className="menu-section">
        <button type="button" className="menu-btn-main">
          <span className="material-icons-round">
            paid
          </span>
          <p>Financeiro</p>
        </button>

        <div className="sub-menu-invisible">
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/financeiro')}>
              <span className="material-icons-round">
                category
              </span>
              Receitas / Despesas
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/financeiro/entradas-futuras')}>
              <span className="material-icons-round">
                category
              </span>
              Projeção financeira
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/dashboard/relatorio/parcelas')}>
              <span className="material-icons-round">
                category
              </span>
              Relatório de parcelas
            </button>
          </div>
        </div>
      </div>

      <div className="menu-section">
        <button type="button">
          <span className="material-icons-round">
            shopping_basket
          </span>
          <p>Credenciados</p>
        </button>

        <div className="sub-menu-invisible">
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/credenciados')}>
              <span className="material-icons-round">
                category
              </span>
              Parceiros
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/profissionais')}>
              <span className="material-icons-round">
                category
              </span>
              Profissionais
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/exames/categoria')}>
              <span className="material-icons-round">
                category
              </span>
              Categoria de exames
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/procedimentos/categoria')}>
              <span className="material-icons-round">
                category
              </span>
              Categoria de procedimentos
            </button>
          </div>
        </div>
      </div>

      <div className="menu-section">
        <button type="button" className="menu-btn-main">
          <span className="material-icons-round">
            table_chart
          </span>
          <p>Tabela de serviços</p>
        </button>

        <div className="sub-menu-invisible">
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/credenciados/filtro')}>
              <span className="material-icons-round">
                category
              </span>
              Lista de parceiros
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/consultas/visualizar')}>
              <span className="material-icons-round">
                category
              </span>
              Exibir Consultas
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/exames/visualizar')}>
              <span className="material-icons-round">
                category
              </span>
              Exibir Exames
            </button>
          </div>
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/procedimentos/visualizar')}>
              <span className="material-icons-round">
                category
              </span>
              Exibir Procedimentos
            </button>
          </div>
        </div>
      </div>

      <div className="menu-section">
        <button type="button" onClick={() => navigate('/usuarios')}>
          <span className="material-icons-round">
            admin_panel_settings
          </span>
          <p>Administradores</p>
        </button>
      </div>

      <div className="menu-section">
        <button type="button" onClick={() => navigate('/configuracoes')}>
          <span className="material-icons-round">
            settings_applications
          </span>
          <p>Configuração</p>
        </button>
      </div>

      <div className="menu-section">
        <button type="button" onClick={() => null}>
          <span className="material-icons-round">
            payments
          </span>
          <p>Gateways de pagamento</p>
        </button>
        <div className="sub-menu-invisible">
          { (id === 2 || id === 3) && (
            <div className="invisible-item">
              <button type="button" onClick={() => navigate('/previsao-por-gateway')}>
                <span className="material-icons-round">
                  category
                </span>
                Prazos de repasse
              </button>
            </div>
          )}
          <div className="invisible-item">
            <button type="button" onClick={() => navigate('/taxas')}>
              <span className="material-icons-round">
                category
              </span>
              Taxas
            </button>
          </div>
        </div>

      </div>

    </div>
  );
}
